/* globals VXConfig VXBannerConfig */
import React                       from 'react';
import PropTypes                   from 'prop-types';
import Header                      from './Header';
import ButtonRow                   from './ButtonRow';
import Block                       from './../Block';
import Translations                from '../../../utils/Translations';
import Flux                        from '../../../flux/Flux';
import {getPromotionBadge}         from "../../../utils/HappyHourHelper";
import {trackClick, trackCTAClick} from '../../../utils/GAHelper';
import ActionAnimation             from "../../SimpleElements/ActionAnimation";
import UrlBuilder                  from "../../../utils/UrlBuilder";
import Grid2            from "../../Grid2/Grid2";
import ActorTile        from "../../Grid2/Tiles/ActorTile";
import withActors       from '../../HigherOrderComponents/Actors/withActors';
import withStaticLoader from '../../HigherOrderComponents/Utility/withStaticLoader';
import {ONLINE_FILTER, generateModelsV3Filter}  from "../../Cams/CamsHelper";

const Grid    = withActors(withStaticLoader(Grid2));
const GRID_ID = 'top-cams-grid';

function getShowGoldrushStoerer() {
    return VXConfig.showGoldrushStoerer;
}

class TopLiveCamGirlsBlock extends React.Component {
	constructor(props) {
		super(props);

		let filter = [{gender: {eq: "F"}}];
		if (VXConfig.language === 'es') {
			filter.push(ONLINE_FILTER);
		}

		filter = {and: filter};

		this.state = {
			total:               this.props.tileGridTotal,
			tiles:               this.getTilesByWindowSize(),
			order:               Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING,
			filter:              filter,
			loading:             true,
			isTeaserShown:       Flux.Teaser.hasTeasers(),
			tileSizes:           this.getTileSizes(),
			link:                this.props.link,
            showGoldrushStoerer: getShowGoldrushStoerer(),
            totalOnline:         this.getTotalOnlineCount(),
		};

		this.onResize                = this.onResize.bind(this);
		this.onActorDataLoadChange   = this.onActorDataLoadChange.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addWindowResizeListener(this.onResize);
		Flux.Actors.addActorsDataLoadListener(this.onActorDataLoadChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onResize);
		Flux.Actors.removeActorsDataLoadListener(this.onActorDataLoadChange);
	}

	onActorDataLoadChange() {
		const loading = Flux.Actors.isActorsDataLoading(this.state.filter, this.state.order);
		const totalOnline = this.getTotalOnlineCount();
		this.setState({loading, totalOnline});
	}

    getTotalOnlineCount() {
        return Flux.Actors.getActorsTotalCount(generateModelsV3Filter([], true), Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING, "") || 0;
    }

	onResize() {
		this.setState({
			tiles:     this.getTilesByWindowSize(),
			tileSizes: this.getTileSizes(),
		});
	}

	getTilesByWindowSize() {
		if (this.props.isMobile) {
			if (Flux.Browser.getWindowSize().width >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.lg) {
				return this.props.showHighlightGrid ? 7 : 10;
			} else if (Flux.Browser.getWindowSize().width >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) {
				return this.props.showHighlightGrid ? 5 : 8;
			} else if (Flux.Browser.getWindowSize().width >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm) {
				return this.props.showHighlightGrid ? 6 : 9;
			}
			return this.props.showHighlightGrid ? 5 : 8;
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm) {
			return this.props.showHighlightGrid ? 12 : 14;
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) {
			return this.props.showHighlightGrid ? 12 : 15;
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.lg) {
			return this.props.showHighlightGrid ? 9 : 12;
		}
		return this.props.showHighlightGrid ? 12 : 15;
	}

	getTileSizes() {
		if (!this.props.showHighlightGrid) {
			return [{index: 0, size: 1}];
		} else if (this.props.isMobile) {
			return [{index: 0, size: 2}];
		} else if (Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md) {
			return [{index: 0, size: 1}];
		}
		return [{index: 0, size: 2}];
	}

	render() {
		const noBorder         = this.state.isTeaserShown ? ' has-no-border' : '';
		const first            = this.props.isMobile ? 10  : 9;
		const columns          = {xs: 2, sm: 3, md: 4, lg: 4};
		const additionalStyles = {};
		if (this.state.showGoldrushStoerer) {
			if (VXConfig.isVXMobilePlatform) {
				additionalStyles.marginTop = "50px";
			} else if (VXBannerConfig.default === undefined || VXBannerConfig.default.length === 0) {
				additionalStyles.marginTop = "70px";
			}
		}

		return (
			<Block className={'top-cam-girls' + noBorder} idName="top-live-block" additionalStyle={additionalStyles}>
				<Header
					title={this.props.title}
					hasCount={!this.props.isMobile && this.state.totalOnline > 0}
					count={this.state.totalOnline}
					countLabel={Translations.get('HomepageV2TopLiveCamGirlsPlural')}
					promotionBadgeUrl={getPromotionBadge()}
					headlineType={this.props.headlineType}
				/>
				{this.state.showGoldrushStoerer &&
					<ActionAnimation className="animation-topcam animation-topcam--goldrush"
					                 link={UrlBuilder.buildGoldrushRoute()}
					                 onClick={() => {
						                 trackClick('goldrushstoerer', UrlBuilder.buildGoldrushRoute());
					                 }}
					>
					</ActionAnimation>}
				{VXConfig.showAdventCalendarStoerer &&
					<ActionAnimation className="animation-topcam animation-topcam--adventcalendar"
					                 link={UrlBuilder.buildAdventCalendarRoute()}
					                 onClick={() => {
						                 trackClick('adventcalendarstoerer', UrlBuilder.buildAdventCalendarRoute());
					                 }}
					>
					</ActionAnimation>}
				{VXConfig.showWetNWildStoerer &&
					<ActionAnimation className="animation-topcam animation-topcam--wetnwild"
					                 link={UrlBuilder.buildWetNWildRoute()}
					                 animation={"/assets/img/special/stoerer/wetnwildstoereranimation2023.gif"}
					                 onClick={() => {
						                 trackCTAClick('wetnwildstoerer', UrlBuilder.buildWetNWildRoute());
					                 }}
					>

					</ActionAnimation>}
				<Grid
					//Grid2
					defaultTileClass={ActorTile}
					columns={columns}
					tilePadding={Flux.Constants.Grid2.TilePadding.SMALL}
					headlineType={'div'}
					defaultTileConfig={{}}
					tileSizes={this.state.tileSizes}

					//Loader
					useFullscreenLoader={false}
					loading={this.state.loading}

					//withActors
					removeSedcard={false}
					first={first}
					filter={this.state.filter}
					order={this.state.order}
					offset={0}
					id={GRID_ID}
					isLoadMore={false}
					useCache={false}
					total={this.state.total}
					isMobile={this.props.isMobile}
					maxTiles={this.state.tiles}
					isV3={true}
                    onlineFilter={ONLINE_FILTER}
				/>
				<ButtonRow
					cta={Translations.get('HomepageV2TopLiveCamGirlsCTA')}
					link={this.state.link}
					callback={() => this.props.doGaTracking ? trackClick('cams', this.state.link) : null}
				/>
			</Block>
		);
	}
}

TopLiveCamGirlsBlock.propTypes = {
	tileGridConfig:    PropTypes.object,
	link:              PropTypes.string,
	tileGridTotal:     PropTypes.number,
	isMobile:          PropTypes.bool,
	showHighlightGrid: PropTypes.bool,
	lazyImageLoading:  PropTypes.bool,
	headlineType:      PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	title:             PropTypes.string,
	doGaTracking:      PropTypes.bool,
};

TopLiveCamGirlsBlock.defaultProps = {
	tileGridTotal:     0,
	isMobile:          false,
	showHighlightGrid: true,
	lazyImageLoading:  false,
	headlineType:      Flux.Constants.Headlines.h2,
	title:             Translations.get('HomepageV2TopLiveCamGirls'),
	doGaTracking:      false,
};

export default TopLiveCamGirlsBlock;
